/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPillOff = createReactComponent("outline", "pill-off", "IconPillOff", [["path", { "d": "M10.495 6.505l2 -2a4.95 4.95 0 0 1 7 7l-2 2m-2 2l-4 4a4.95 4.95 0 0 1 -7 -7l4 -4", "key": "svg-0" }], ["path", { "d": "M8.5 8.5l7 7", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconPillOff as default };
//# sourceMappingURL=IconPillOff.mjs.map
